import React from 'react'
import translate from '../../../reusable/translate'
import { Link } from "react-router-dom"
import {isMaterialOrGD} from "../../../materialCommitment/helpers/Categories";
import moment from "moment";


const ReportingHeader = ({commitment}) => {

    const getHref = () => {
        switch (commitment.commitmentCategoryId){
            case 237431:
                return 'autoala#/'
            case 284155:
                return 'oljyjatehuolto#/'
            case 386044:
                return 'tyokone#/'
            case 427415:
                return 'kestavapurkaminen#/'
            case 496637:
                return 'paastotontyomaa#/'
            case 522123:
                return 'varhaiskasvatus#/'
            case 583993:
                return 'rakentamisen-muovit#/'
            case 583645:
                return 'matsit/elintarvikeala#/'
            case 623511:
                return 'jatevesi#/'
            case 664314:
                return 'muoviset-annospakkaukset#/'
            case 664388:
                return 'muoviset-annospakkaukset#/'
            default:
                return 'tietoa-green-dealista#/'
        }

    }



    const isAlreadyReported = () =>{
        if (!isMaterialOrGD(commitment.commitmentType)) return false;
        const lastYearStart = moment().startOf('year').subtract(1, 'year')
        const lastYearEnd = moment().endOf('year').subtract(1, 'year')
        let isReported = false;
        try{
        commitment.operations.forEach( (operation) =>
            operation.reports.forEach( (report) =>
                    isReported = (report.reportStartDate && moment(report.reportStartDate).isBetween(lastYearStart, lastYearEnd, 'undefined', '[]') &&
                        report.reportEndDate && moment(report.reportEndDate).isBetween(lastYearStart, lastYearEnd, 'undefined', '[]') 
                        && report.status === "approved"  )
            )
        )} catch (e) {
            // Nothing to do
        }
        return isReported;
    }

    return(
        <div>
            {/* Back button */}
            <Link to={{pathname: "/sitoumukset"}}>
                <button className="green-button">
                    {"<"}  {translate({ textKey: "sit.back" })}
                </button>
            </Link>

            {/* Commitment name */}
            <h1 className="border-bottom">
                {commitment.title_fi_FI}
            </h1>


            <div>
                <a href="https://sitoumus2050.fi/ohjeita" target="_blank"
                   rel="noopener noreferrer">{translate({textKey: 'sit.reporting.instructions'})}</a>
                <br/>
                {isMaterialOrGD(commitment.commitmentType) && translate({textKey: 'sit.reporting.drafting.info'})}
                <br/>
            </div>

            {isAlreadyReported() && translate({textKey: 'sit.reporting.already.reported'})}

        </div>
    )
}

export default ReportingHeader


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ReportingHeader.jsx